import { render, staticRenderFns } from "./UserEntry.vue?vue&type=template&id=139279df&scoped=true"
import script from "./UserEntry.vue?vue&type=script&lang=js"
export * from "./UserEntry.vue?vue&type=script&lang=js"
import style0 from "./UserEntry.vue?vue&type=style&index=0&id=139279df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139279df",
  null
  
)

export default component.exports